export function pagination(page, pageCount) {


    $('.js-pag-plus1').remove();
    $('.js-pag-plus2').remove();
    $('.js-pag-plus3').remove();
    $('.js-pag-minus1').remove();
    $('.js-pag-minus2').remove();
    $('.js-pag-minus3').remove();
    $('.js-pag-dots').remove();

    // Update page number
    $('.pag-current-page').text(page);

    $('.js-pagination').removeClass('hide');

    // Last page in pagination
    $('.pag-last-page').text(pageCount);

    if (  pageCount === 1  ) {
        $('.js-pagination').addClass('hide');
    }

    // First page
    if (  page === 1  ) {

        // Previous button
        $('.pag-previous-page').hide();

        // First Button
        $('.pag-first-page').addClass('selected');

        // Last button
        $('.pag-last-page').removeClass('selected');

        // Next button
        $('.pag-next-page').show();

        // Current page
        $('.pag-current-page').hide().removeClass('selected');


        // If page count is less than 3
        if ( pageCount <= 2 ) {

            
        } else if ( pageCount <= 3 ) {

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' 
            );

        } else if ( pageCount <= 4 ) {

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
            );

        } else if ( pageCount <= 5 ) {

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>'
            );

        } else { 

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );
        }
        
    // Last page
    } else if ( page === pageCount ) {

        // Previous button
        $('.pag-previous-page').show();

        // First Button
        $('.pag-first-page').removeClass('selected');

        // Last button
        $('.pag-last-page').addClass('selected');

        // Next button
        $('.pag-next-page').hide();

        // Current page
        $('.pag-current-page').hide().removeClass('selected');

        // If page count is less than 3
        if ( pageCount <= 2 ) {

            
        } else if ( pageCount <= 3 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>' 
            );

        } else if ( pageCount <= 4 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>' 
            );

        } else if ( pageCount <= 5 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );


        } else { 

            $('.pag-current-page').before(
                '<span class="js-pag-dots lhs pagination-button">...</span>' + 
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'		
            );
        }


    // If we are on 2nd page
    } else if( page === 2) {

        $('.js-pag-button').show().removeClass('selected');
        $('.pag-current-page').show().addClass('selected');

        // If the page count is 3
        if ( pageCount <= 3 ) {

        // If page count is 4
        } else if ( pageCount <= 4 ) {

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'

            );

        } else if ( pageCount <= 5 ) {

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
            );

        } else if ( pageCount <= 6 ) {

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>'
            );

        } else { 

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );
        }


    // If we are on 3rd page
    } else if( page === 3) {

        $('.js-pag-button').show().removeClass('selected');
        $('.pag-current-page').show().addClass('selected');

        // If page count is 4
        if ( pageCount <= 4 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

        } else if ( pageCount <= 5 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'
            );

        } else if ( pageCount <= 6 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
            );

        } else if ( pageCount <= 7 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>'
            );


        } else {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );
        }

    // If we are on 4th page
    } else if( page === 4) {

        $('.js-pag-button').show().removeClass('selected');
        $('.pag-current-page').show().addClass('selected');

        // If page count is 5
        if ( pageCount <= 5 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

        } else if ( pageCount <= 6 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );
            
            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'
            );

        } else if ( pageCount <= 7 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
            );

        } else {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );
        }

        

    // If we are on 5th page
    } else if( page === 5) {

        $('.js-pag-button').show().removeClass('selected');
        $('.pag-current-page').show().addClass('selected');

        if ( pageCount <= 6 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

        } else if ( pageCount <= 7 ) {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'
            );


        } else {

            $('.pag-current-page').before(
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $('.pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );

        }

    // If we are 2nd to last page
    } else if( page === (pageCount-1)) {

        $('.js-pag-button').show().removeClass('selected');
        $('.pag-current-page').show().addClass('selected');


        // If page count is less than 3
        if ( pageCount <= 3 ) {

        } else { 

            $('.pag-current-page').before(
                '<span class="js-pag-dots lhs pagination-button">...</span>' + 
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'	
            );
        }


    // If we are 3rd to last page
    } else if( page === (pageCount-2)) {

        $('.js-pag-button').show().removeClass('selected');
        $('.pag-current-page').show().addClass('selected');

        $('.pag-current-page').before(
            '<span class="js-pag-dots lhs pagination-button">...</span>' + 
            '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
            '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
            '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
        );

        $('.pag-current-page').after(
            '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'
        );

    // If we are 4th to last page
    } else if( page === (pageCount-3)) {

        $('.js-pag-button').show().removeClass('selected');
        $('.pag-current-page').show().addClass('selected');

        $('.pag-current-page').before(
            '<span class="js-pag-dots lhs pagination-button">...</span>' + 
            '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
            '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
            '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
        );

        $('.pag-current-page').after(
            '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
            '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
        );


    // If we are 5th to last page
    } else if( page === (pageCount-4)) {

        $('.js-pag-button').show().removeClass('selected');
        $('.pag-current-page').show().addClass('selected');

        $('.pag-current-page').before(
            '<span class="js-pag-dots lhs pagination-button">...</span>' + 
            '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
            '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
            '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
        );

        $('.pag-current-page').after(
            '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
            '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
            '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>'
        );


    } else {


        $('.js-pag-button').show().removeClass('selected');
        $('.pag-current-page').show().addClass('selected');

        $('.pag-current-page').before(
            '<span class="js-pag-dots lhs pagination-button">...</span>' +
            '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
            '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
            '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
        );

        $('.pag-current-page').after(
            '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
            '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
            '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
            '<span class="js-pag-dots lhs pagination-button">...</span>'
        );

    }
}